class SvgInjector {
  constructor() {
    this.imageEl = document.querySelectorAll('img[src*=".svg"]');

    this.inject = this.inject.bind(this);
    this.handleImages();
  }

  handleImages() {
    const self = this;
    Array.from(this.imageEl).forEach(function (image, index) {
      if (image.getAttribute('src')) {
        self.inject(image, index);
      }
    });
  }

  /**
   * @param {Element} image
   * @param {number} index
   */
  inject(image, index) {
    const imageId = image.getAttribute('id');
    const imageClass = image.getAttribute('class');
    const imageSrc = image.getAttribute('src');
    const imageTitle = image.getAttribute('title');
    const imageAlt = image.getAttribute('alt');
    const xhr = new XMLHttpRequest();
    xhr.open('GET', imageSrc);
    xhr.onreadystatechange = function () {
      if (xhr.readyState === 4 && xhr.status === 200) {
        const xml = xhr.responseXML;
        const node = xml.getElementsByTagName('svg')[0];
        node.setAttribute('role', 'img');
        node.setAttribute('aria-hidden', 'true');

        if (typeof imageId !== 'undefined' && imageId !== null) {
          node.setAttribute('id', imageId);
        }

        if (typeof imageClass !== 'undefined' && imageClass !== null) {
          node.setAttribute('class', imageClass + ' replaced-svg');
        } else {
          node.setAttribute('class', 'replaced-svg');
        }

        if (typeof imageAlt !== 'undefined' && imageAlt !== null && imageAlt !== '') {
          const descId = 'svg-desc-' + index;
          const descNode = xml.createElement('desc');
          descNode.setAttribute('id', descId);
          descNode.appendChild(xml.createTextNode(imageAlt));
          node.removeAttribute('aria-hidden');
          node.setAttribute('aria-labelledby', descId);
          node.insertBefore(descNode, node.childNodes[0]);
        }

        if (typeof imageTitle !== 'undefined' && imageTitle !== null && imageTitle !== '') {
          const titleId = 'svg-title-' + index;
          const titleNode = xml.createElement('title');
          titleNode.setAttribute('id', titleId);
          titleNode.appendChild(xml.createTextNode(imageTitle));

          let attributeValue = node.getAttribute('aria-labelledby');
          if (attributeValue !== null) {
            attributeValue = titleId + ' ' + attributeValue;
          } else {
            attributeValue = titleId;
          }

          node.removeAttribute('aria-hidden');
          node.setAttribute('aria-labelledby', attributeValue);
          node.insertBefore(titleNode, node.childNodes[0]);
        }

        image.parentNode.insertBefore(node, image);
        image.remove();
      }
    };
    xhr.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
    xhr.send();
  }
}

new SvgInjector();
